import { DataPath } from '../../DataPath';
import { DateTime } from '../../DateTime';
import { ParseNode } from '../../Parse/ParseNode';
import { ExprForm } from '../ExprForm';
import { ExprPath } from '../ExprPath';
import { Generic } from './Generic';
export var DatePart;
(function (DatePart) {
    function matches(root) {
        if (root.type === "CallExpression" &&
            root.callee.toUpperCase() === 'DATEPART') {
            const arity = root.arguments.length;
            if (arity >= 2 && arity <= 4) {
                return (root.arguments[0].type === "StringLiteral" &&
                    ParseNode.isAccess(root.arguments[1]) &&
                    (arity > 2
                        ? root.arguments[2].type === "StringLiteral"
                        : true) &&
                    (arity > 3
                        ? root.arguments[3].type === "StringLiteral"
                        : true));
            }
        }
        return false;
    }
    DatePart.matches = matches;
    let Parsed;
    (function (Parsed) {
        function make(root) {
            const generic = () => Generic.Parsed.make(root);
            if (!matches(root)) {
                return generic();
            }
            const [unitNode, accessNode, weekStartNode, yearStartNode] = root.arguments;
            const unit = DateTime.unit(unitNode.type === "StringLiteral" ? unitNode.value : '');
            if (unit == null) {
                return generic();
            }
            const path = ExprPath.fromParseNode(accessNode);
            if (path.type === "EMPTY") {
                return generic();
            }
            let weekStart;
            if (weekStartNode) {
                weekStart = DateTime.weekStart(weekStartNode.type === "StringLiteral"
                    ? weekStartNode.value
                    : '');
                if (weekStart == null) {
                    return generic();
                }
            }
            let yearStart;
            if (yearStartNode) {
                yearStart = DateTime.yearStart(yearStartNode.type === "StringLiteral"
                    ? yearStartNode.value
                    : '');
                if (yearStart == null) {
                    return generic();
                }
            }
            let name = `${unit}(${DataPath.name(path)})`;
            if (weekStart) {
                switch (unit) {
                    case "WEEK": {
                        name = `${unit}(${DataPath.name(path)}, ${weekStart})`;
                        break;
                    }
                }
            }
            if (yearStart) {
                switch (unit) {
                    case "YEAR":
                    case "QUARTER": {
                        name = `${unit}(${DataPath.name(path)}, ${yearStart})`;
                        break;
                    }
                }
            }
            return {
                state: "PARSED",
                form: ExprForm.DatePart,
                name,
                path,
                root,
                unit,
                weekStart,
                yearStart,
            };
        }
        Parsed.make = make;
    })(Parsed = DatePart.Parsed || (DatePart.Parsed = {}));
    let Compiled;
    (function (Compiled) {
        function make(expr, stage, data) {
            return {
                ...expr,
                state: "COMPILED",
                stage,
                data,
            };
        }
        Compiled.make = make;
    })(Compiled = DatePart.Compiled || (DatePart.Compiled = {}));
})(DatePart || (DatePart = {}));
